// Angular Core
import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { ROUTES } from './clpbp-app.settings';

@Component({
  selector: 'ld-clpbp-app',
  templateUrl: './clpbp-app.component.html',
  styleUrls: ['./clpbp-app.component.css']
})
export class CLPBPAppComponent {

  constructor(private router: Router) {}

  isLogin(): boolean {
    return (this.router.url.indexOf('login') > -1 || this.router.url.indexOf('sign-in') > -1 );
  }
}
